import { HasOwnProperty } from "../262.mjs";
function CurrencyDigits(c, _a) {
  var currencyDigitsData = _a.currencyDigitsData;
  return HasOwnProperty(currencyDigitsData, c) ? currencyDigitsData[c] : 2;
}
export {
  CurrencyDigits
};
